import { fromJS } from 'immutable'

import { SHOW_MODAL, HIDE_MODAL } from './../../constants'

const initialState = fromJS({
//   status: false,
//   modalType: List(),
})

export default (state = initialState, action) => {
  switch (action.type) {
    case SHOW_MODAL:
      return state
        .set('modalStatus', action.modalStatus)
        .set('modalType', action.modalType)
        .set('modalMessage', action.modalMessage)
    case HIDE_MODAL:
      return state
        .delete('modalStatus')
        .delete('modalType')
        .delete('modalMessage')
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./src/reducers/modal/modal-reducer.js